export default "__VITE_ASSET__q55T3iUS__"